import React from 'react';
import {reduxForm} from 'redux-form';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper';
import CheckMarkCell from '../../../../Common/CustomGridCells/CheckMarkCell/checkMarkCell';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell.js';
import {gridsNames} from '../../../../../enums/gridsNames';
import {filterTypes} from 'infrastructure/js/enums/filterTypes';
import {EntityPropertyTypes} from '../../../../../enums/entityPropertyTypes';
import {FetchEntitiesFilters} from '../../../../../enums/fetchEntitiesFilters';

class OperationsViewGrid extends React.PureComponent{

  filterConfig = [
    {fieldName: 'displayName', filterName: 'displayName', getOptions: false},
    {fieldName: 'operationType', filterName: 'operationType', getOptions: true}
  ];

  constructor (props){
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.operations.grid.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'operationType',
        title: this.labels.get('columns.operationtype.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'operationType',
        columnOptions: {
          sort: 'desc',
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'displayName',
        title: this.labels.get('columns.displayname.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'displayName',
        width: 180,
        fetchConfig: {
          entityType: EntityPropertyTypes.OPERATION_NAME,
          filter: [FetchEntitiesFilters.ALL],
          action: this.props.actions.fetchEntities
        },
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
        }
      },
      {
        fieldName: 'instructions',
        title: this.labels.get('columns.instructions.title'),
        filterType: filterTypes.NONE,
        columnOptions: {
          sortable: false,
          cellComponent: LabelWithTooltipCell,
        }
      }
    ]
  };

  render() {
    return (
      <div className="administration-view-grid">
        <Grid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_OPERATIONS}
              columnsConfig = {this.columnsConfig}
              actions={this.props.actions}
              filterConfig={this.filterConfig}
        >
        </Grid>
      </div>
    );
  }
}

export default reduxForm({
    form: 'operationsViewGrid'
  }
)(OperationsViewGrid);
